module.exports = __webpack_public_path__ + "media/bootstrap-icons/mouse-fill-e11df04c.svg";